$(() => {
    // Set viewport height
    // This is to stop mobile browser's toolbar interfering with our viewport heights.
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));

    // // Handles screen resizes and resets values based on new viewport dimenions
    // function resizeHandler()
    // {
    //     // Set viewport height
    //     var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document
    //     document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    // }
    //
    // window.addEventListener('resize', _.debounce(resizeHandler, 50));
    //

    // Main navigation toggle
  $('#c-menu-trigger').on("click", function() {
     $(this).attr('aria-expanded', !$('body').hasClass('nav-open'));
     $('html, body').toggleClass('nav-open');
 });
})
